import React, { FC, useCallback } from "react";
import {
  ContentWrapper,
  Heading,
} from "containers/RightPanel/RightPanel.styles";
import { ButtonColor, ButtonVariant } from "enums/Button";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import { OpenRightPanel } from "types/common/rightPanel";
import { Content } from "../../../../components/Addresses/components/AddressForm.styles";
import Button from "../../../../components/Button/Button";
import Input from "../../../../components/Input/Input";
import {
  deletePrintUser,
  getPrintUsers,
} from "../../../../reduxFolder/reducers/printUsers";
import {
  closeRightPanel,
  openRightPanel,
} from "../../../../reduxFolder/reducers/rightPanel";
import { toastResponseError } from "../../../../utils/responseMessageHelper";

interface PrintUserViewPanelProps {
  panelData: any;
  isOpen: boolean;
  closeRightPanel: () => void;
  openRightPanel: OpenRightPanel;
  deletePrintUser: (data: { id: number }) => Promise<any>;
  getPrintUsers: () => void;
}

const PrintUserViewPanel: FC<PrintUserViewPanelProps> = ({
  panelData,
  closeRightPanel,
  openRightPanel,
  deletePrintUser,
  getPrintUsers,
}) => {
  const { t } = useTranslation("common");
  const printUser = panelData.get("printUser");

  const createdAt = printUser.get("created_at");
  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString()
    : "";

  const handleEdit = useCallback(() => {
    openRightPanel("PRINT_USER_FORM", Map({ printUser }));
  }, [openRightPanel, printUser]);

  const handleChangePassword = useCallback(() => {
    openRightPanel("PRINT_USER_PASSWORD", Map({ printUser }));
  }, [openRightPanel, printUser]);

  const handleDelete = useCallback(() => {
    if (window.confirm(t("tools.deleteConfirmation"))) {
      deletePrintUser({ id: printUser.get("id") })
        .then(() => {
          closeRightPanel();
          getPrintUsers();
        })
        .catch(toastResponseError);
    }
  }, [deletePrintUser, printUser, closeRightPanel, getPrintUsers, t]);

  return (
    <ContentWrapper>
      <Heading>{t("tools.viewPrintUser")}</Heading>
      <ViewContent>
        <Input
          label={t("tools.email")}
          value={printUser.get("email")}
          disabled
        />
        <Input
          label={t("tools.createdAt")}
          value={formattedDate}
          disabled
        />
      </ViewContent>
      <ButtonsRow>
        <Button onClick={handleEdit} variant={ButtonVariant.Filled}>
          {t("tools.editPrintUser")}
        </Button>
        <Button onClick={handleChangePassword} variant={ButtonVariant.Bordered}>
          {t("tools.changePassword")}
        </Button>
        <Button onClick={handleDelete} color={ButtonColor.Red}>
          {t("tools.deletePrintUser")}
        </Button>
      </ButtonsRow>
    </ContentWrapper>
  );
};

const withConnect = connect(null, {
  closeRightPanel,
  openRightPanel,
  deletePrintUser,
  getPrintUsers,
});

export default withConnect(PrintUserViewPanel);

const ViewContent = styled(Content)`
  label {
    margin-bottom: 10px;
  }
`;

const ButtonsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 15px 0;
`;
